export const updateFilterValueInSearchParams = ({ searchParams, activeValues, value, key, singleSelect = false }) => {
    if (singleSelect) {
        if (activeValues.includes(value)) {
            searchParams.delete(key);
        }
        else {
            searchParams.set(key, value);
        }
        return searchParams;
    }
    if (activeValues.includes(value)) {
        activeValues = activeValues.filter(v => v !== value);
    }
    else {
        activeValues.push(value);
    }
    if (activeValues.length > 0) {
        searchParams.set(key, activeValues.join(','));
    }
    else {
        searchParams.delete(key);
    }
    return searchParams;
};
